export default __webpack_public_path__ + "static/media/PF_08.7cf6c61e.png";